import Vue from 'vue';
import { decimal } from 'vuelidate/lib/validators';
import stickyDoughnutUrls from '../../../../urls/stickyDoughnutUrls';

export const storePrefix = "sticky_doughnut_store";

const state = {
    sessionStorageKey: "sticky_doughnut",
    doughnutValues: {},
    isGettingRates: false,
}

const getters = {
    doughnutValues(state) {
        return state.doughnutValues;
    },

    isGettingRates(state) {
        return state.isGettingRates;
    },
}

const mutations = {
    [`${storePrefix}setDoughnutValues`](state, payload) {
        state.doughnutValues = payload;
    },

    [`${storePrefix}setIsGettingRates`](state, payload) {
        state.isGettingRates = payload;
    },
}

const actions = {

    getCampaignRates(context, campaignRatesObj) {
        return new Promise((resolve, reject) => {
            Vue.$http.post(stickyDoughnutUrls.getCampainRates, campaignRatesObj)
                .then((res) => resolve(res.data))
                .catch(err => reject(err));
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/components/Common/StickyDoughnut/store/stickyDoughnut.js